import { Component, OnDestroy, inject } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BellNotficationService } from '@core/services/bell-notification.service';
import { BellNotficationApiService } from '@core/services/bell-notification.api.service';
import { EmployeeInfoService } from '@core/services/employee-info.service';
import { UtilityService } from '@core/services/utility.service';
import { ApiResponse } from '@shared/model/api-response.model';
import { AlertModalComponent } from '@modals/shared/alert-modal/alert-modal.component';
import { BellNotificationModel } from '@typeDefs/home/responses/home';

@Component({
  selector: 'app-bell-notification',
  templateUrl: './bell-notification.component.html',
  styleUrls: ['./bell-notification.component.css'],
  standalone: false,
})
export class BellNotificationComponent implements OnDestroy {
  private readonly employeeInfoService = inject(EmployeeInfoService);
  private readonly utilityService = inject(UtilityService);
  public readonly bellNotficationService = inject(BellNotficationService);
  private readonly bellNotficationApiService = inject(BellNotficationApiService);
  private modalService = inject(BsModalService);

  readonly employeeInfo = this.employeeInfoService.getEmployeeInfo();
  readonly dateFormat = this.utilityService.getDateFormat().toLowerCase().replace('mm', 'MM') + ' h:mm:ss a';
  readonly isMobile = this.utilityService.isMobileMode();

  public ngOnDestroy(): void {
    this.bellNotficationService.onDestroy();
  }

  onclickBellNotificationDropdown(): void {
    this.bellNotficationService.hasNewNotification = false;
  }

  executeActionURL(event: Event, bellNotification: BellNotificationModel): void {
    if (bellNotification.Status == 2 && bellNotification.ErrorMessage != null) {
      // display error in modal
      const initialState = {
        modalData: {
          modalTitle: 'Error excuting Job',
          modalMessage: bellNotification.ErrorMessage,
          alertLevel: 'danger',
          useCopyButton: true,
        },
        backdrop: 'static',
      };
      this.modalService.show(AlertModalComponent, { initialState, ignoreBackdropClick: true });
      return;
    }

    if ((bellNotification.Status != 1 && bellNotification.Status != 4) || bellNotification.ActionURL == null) {
      // prevent dropdown from closing
      event.stopPropagation();
      return;
    }

    if (this.bellNotficationService.bellNotifications.length > 1) {
      // prevent dropdown from closing
      event.stopPropagation();
    }

    this.bellNotficationService.executeActionURL(
      this.employeeInfo.UserKeyID,
      bellNotification.BellNotificationID,
      bellNotification.ActionType,
      bellNotification.ActionURL
    );
  }

  dismissBellNotification(event: Event, bellNotificationId: bigint): void {
    if (this.bellNotficationService.bellNotifications.length > 1) {
      // prevent dropdown from closing
      event.stopPropagation();
    }

    this.bellNotficationApiService.dismissBellNotification(this.employeeInfo.UserKeyID, bellNotificationId).subscribe({
      next: (response: ApiResponse) => {
        if (response.success) {
          this.bellNotficationService.removeBellNotification(bellNotificationId);
        }
      },
    });
  }
}
